





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import LatestRequest from "@/core/HttpResources/LatestRequest";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import Persona from "@/models/persona/persona.model";
import { Utils } from "@/core/Utils";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarInclusion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar/";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import NameValue from "@/models/nameValue.model";
import { TipoTramiteCode } from "@/enums/TipoTramiteCode";
import Helpers from '@/helpers/helper';
import externalService from '@/services/external.service';
import BaseHttpClient from '@/core/HttpResources/BaseHttpClient';


@Component
export default class CambioComposicionFamiliarInclusion extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly codigoDocAdicionales!: string;
  @Prop() readonly content!: TramiteBeneficiario;

  miembroTableConfig: BTableConfig<Miembro> | null = null;
  nameValue = new NameValue();
  TipoTramiteCode = TipoTramiteCode;

  model = new SolicitudCambioComposicionFamiliar();

  personaCopy(val: Persona) {
    return this.copy(val);
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId) {
      let contenido = this.content as any;
      if (contenido) {
        contenido.solicitudCambioComposicionFamiliar.hogarId = this.beneficiario.hogarId;
        this.$emit("update:content", contenido);
      }
      return this.beneficiario.hogarId;
    }
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get miembroPersonas() {
    return this.model.miembrosIncluidos.map(x => x.persona);
  }
  constructor() {
    super();
    this.model.inclusion = true;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoDocAdicionales",
        "string",
        true,
        "Código de docs. adicionales"
      )
    );
    let contenido = this.content as any;
    if (contenido) {
      let main = (contenido.solicitudCambioComposicionFamiliar = this.copy(
        this.model
      ));
      main.inclusion = true;
      contenido.solicitudCambioComposicionFamiliar = main;
      this.$emit("update:content", contenido);
    }
    this.$emit("render", props);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudCambioComposicionFamiliar)
        delete contenido.solicitudCambioComposicionFamiliar;

      this.$emit("update:content", contenido);
    }
  }
  addingMiembro = false;
  repoPersona = new BaseRepository<Persona>("Personas");
   async add(miembro: Miembro) {
    if (
      this.model.miembrosIncluidos.some(x => x.personaId === miembro.personaId)
    ) {
      this.operationNoAllowed(
        "La persona ya es parte de los miembros incluídos"
      );
      return;
    }
    if (miembro.persona) {
      let resultExiste = await this.ExisteMiembroEnComposiciones(miembro.persona);
      if (resultExiste === undefined) return;
      if (resultExiste) {
        if (resultExiste.prosoli){
            this.operationNoAllowed(
              "El miembro que intenta agregar existe en la composición de PROSOLI",
              5000
            );
          this.addingMiembro = false;
          return;

        }
        if (resultExiste.siuben){
              this.operationNoAllowed(
            "El miembro que intenta agregar existe en la composición de SIUBEN",
            5000
          );
        this.addingMiembro = false;
        return;
        }
      }
    if(this.hogarCode && miembro.persona && miembro.persona.cedula){
      let esDeOtraComposicion = await externalService.ExisteMiembroEnOtroHogar(this.hogarCode,miembro.persona.cedula)
      if(esDeOtraComposicion){
        this.operationNoAllowed(
              "El miembro que intenta agregar existe en otra composición familiar",
              5000
            );
          this.addingMiembro = false;
          return;
      }
    }
    }
    if (!miembro.personaId && miembro.persona) {
      this.addingMiembro = true;
      var body = miembro.persona;
      body.cedula = this.quitCedulaMask(body.cedula);
      body.cedulaPadre = this.quitCedulaMask(body.cedulaPadre);
      body.cedulaMadre = this.quitCedulaMask(body.cedulaMadre);
      if (body.telefono)
        body.telefono = Helpers.Filters.PhoneToStr(body.telefono);
      if (body.estaEstudiando) body.ultimoNivelAcademico = "";
      else if (body.estaEstudiando === false) {
        body.centroAcademicoId = undefined;
        body.centroAcademicoOtro = "";
        body.cursoEstudiante = "";
      }
      let p = await this.repoPersona.create(miembro.persona);
      miembro.personaId = p.id;
      miembro.persona = p;
      this.addingMiembro = false;
    }

    let val = new SolicitudCambioComposicionFamiliarInclusion(
      this.hogarId,
      miembro.parentescoId
    );
    val.codHogar = miembro.codigoHogar;
    val.razonInclusionId = miembro.razonInclusionId;
    val.razonInclusionOtro = miembro.razonInclusionOtro;
    val.personaId = miembro.personaId;
    val.persona = miembro.persona;
    val.parentescoNombre = miembro.parentescoNombre;
    this.model.miembrosIncluidos.push(val);
  }
  checking = false;
  async ExisteMiembroEnComposiciones(persona: Persona) {
    try {
      this.checking = true;
      let dataToSend = {
        codigoHogar: this.hogarCode,
        cedulaJefe: this.solicitante.cedula,
        persona: persona
      };
      var result = (await new BaseHttpClient("Beneficiario").postAsync(
        "CheckMiembroEnComposiciones",
        dataToSend
      )) as any;

      return result;
    } catch (error) {
      if (LatestRequest.isCancelled(error)) return undefined;
      if (LatestRequest.isExternalUnavailable(error)) {
        this.operationNoAllowed("No fue posible validar la información en SIUBEN en este momento. Puede continuar con el trámite.");
        return { prosoli: false, siuben: false };
      }
      throw error;
    }finally{
      this.checking = false;
    }
  }
  removeMiembro(index: number) {
    this.model.miembrosIncluidos.splice(index, 1);
  }
  onLoadTable(config: BTableConfig<Miembro>) {
    this.miembroTableConfig = config;
  }
   quitCedulaMask(cedula?: string) {
    if (cedula) return cedula.replace(/-/g, "");
    return "";
  }
  @Watch("model", { deep: true })
  set(model: SolicitudCambioComposicionFamiliar) {
    let contenido = this.content as any;
    if (contenido) {
      contenido.solicitudCambioComposicionFamiliar = this.map(model);
      contenido.solicitudCambioComposicionFamiliar.miembrosIncluidos.forEach(
        (x: any) => delete x.persona
      );
      this.$emit("update:content", contenido);
    }
  }
  onChangeDocs(
    miembro: SolicitudCambioComposicionFamiliarInclusion,
    tipos: any,
    docs: any[]
  ) {
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudCambioComposicionFamiliarDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  @Watch("codigoDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
